/* Stone Aura v2 — animation engine */
(function () {
  'use strict';
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Hero gold-dust particles (perf: viewport-gated, lighter) ---------- */
  function initParticles() {
    var canvas = document.querySelector('[data-sa-particles]');
    if (!canvas || reduced) return;
    if (navigator.connection && navigator.connection.saveData) return;
    var ctx = canvas.getContext('2d');
    var w, h, parts = [], running = false, raf = null, inView = true;
    function resize() {
      var r = canvas.parentElement.getBoundingClientRect();
      w = canvas.width = r.width;
      h = canvas.height = r.height;
    }
    function make() {
      return {
        x: Math.random() * w,
        y: Math.random() * h,
        r: Math.random() * 2.2 + 0.6,
        vy: -(Math.random() * 0.35 + 0.08),
        vx: (Math.random() - 0.5) * 0.2,
        a: Math.random() * 0.6 + 0.15,
        tw: Math.random() * Math.PI * 2,
        ts: Math.random() * 0.02 + 0.005
      };
    }
    function tick() {
      if (!running) return;
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y += p.vy; p.x += p.vx; p.tw += p.ts;
        if (p.y < -10) { parts[i] = make(); parts[i].y = h + 10; continue; }
        var alpha = p.a * (0.6 + 0.4 * Math.sin(p.tw));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(233, 217, 168,' + alpha.toFixed(3) + ')';
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    }
    function start() { if (running || !inView || document.hidden) return; running = true; tick(); }
    function stop() { running = false; if (raf) { cancelAnimationFrame(raf); raf = null; } }
    resize();
    var n = Math.min(55, Math.floor(w * h / 24000));
    for (var i = 0; i < n; i++) parts.push(make());
    window.addEventListener('resize', resize);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (inView) start(); else stop();
      }, { threshold: 0 }).observe(canvas);
    }
    start();
  }

  /* ---------- Animated counters ---------- */
  function initCounters() {
    var els = document.querySelectorAll('[data-sa-count]');
    if (!els.length) return;
    function animate(el) {
      var target = parseFloat(el.getAttribute('data-sa-count'));
      var suffix = el.getAttribute('data-sa-suffix') || '';
      var decimals = (String(el.getAttribute('data-sa-count')).split('.')[1] || '').length;
      var dur = 1800, start = null;
      function fmt(v) {
        return decimals ? v.toFixed(decimals) : Math.round(v).toLocaleString('en-US');
      }
      function frame(t) {
        if (!start) start = t;
        var p = Math.min(1, (t - start) / dur);
        var eased = 1 - Math.pow(1 - p, 4);
        el.textContent = fmt(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(animate);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animate(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Crystal guide tabs ---------- */
  function initGuide() {
    document.querySelectorAll('[data-sa-guide]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('.sa-guide__tab'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.sa-guide__panel'));
      var timer = null, idx = 0;
      function show(i) {
        idx = (i + tabs.length) % tabs.length;
        tabs.forEach(function (t, ti) { t.classList.toggle('sa-guide__tab--active', ti === idx); t.setAttribute('aria-selected', ti === idx); });
        panels.forEach(function (p, pi) { p.classList.toggle('sa-guide__panel--active', pi === idx); });
      }
      function auto() {
        clearInterval(timer);
        if (reduced) return;
        timer = setInterval(function () { show(idx + 1); }, 6000);
      }
      tabs.forEach(function (t, ti) {
        t.addEventListener('click', function () { show(ti); auto(); });
      });
      root.addEventListener('mouseenter', function () { clearInterval(timer); });
      root.addEventListener('mouseleave', auto);
      show(0); auto();
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdown() {
    document.querySelectorAll('[data-sa-countdown]').forEach(function (root) {
      var target = new Date(root.getAttribute('data-sa-countdown')).getTime();
      if (isNaN(target)) return;
      var dEl = root.querySelector('[data-cd="d"]'),
          hEl = root.querySelector('[data-cd="h"]'),
          mEl = root.querySelector('[data-cd="m"]'),
          sEl = root.querySelector('[data-cd="s"]');
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          root.querySelector('.sa-countdown__timer').innerHTML = '<div style="color:var(--sa-gold-light);font-size:1.8rem;letter-spacing:0.1em;">Offer has ended — stay tuned for the next one.</div>';
          clearInterval(iv); return;
        }
        var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24,
            m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
        if (dEl) dEl.textContent = pad(d);
        if (hEl) hEl.textContent = pad(h);
        if (mEl) mEl.textContent = pad(m);
        if (sEl) sEl.textContent = pad(s);
      }
      var iv = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- 3D tilt on cards ---------- */
  function initTilt() {
    if (!fine || reduced) return;
    document.querySelectorAll('[data-sa-tilt]').forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var rx = ((e.clientY - r.top) / r.height - 0.5) * -10;
        var ry = ((e.clientX - r.left) / r.width - 0.5) * 10;
        card.style.transform = 'perspective(900px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-6px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  /* ---------- Magnetic buttons ---------- */
  function initMagnetic() {
    if (!fine || reduced) return;
    document.querySelectorAll('.sa-magnetic').forEach(function (btn) {
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18;
        var y = (e.clientY - r.top - r.height / 2) * 0.28;
        btn.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
      });
      btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  /* ---------- Hero parallax orbs ---------- */
  function initHeroParallax() {
    if (!fine || reduced) return;
    var hero = document.querySelector('.sa-hero2');
    if (!hero) return;
    var layers = hero.querySelectorAll('[data-sa-depth]');
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      var cx = (e.clientX - r.left) / r.width - 0.5;
      var cy = (e.clientY - r.top) / r.height - 0.5;
      layers.forEach(function (l) {
        var depth = parseFloat(l.getAttribute('data-sa-depth')) || 20;
        l.style.translate = (-cx * depth).toFixed(1) + 'px ' + (-cy * depth).toFixed(1) + 'px';
      });
    });
  }

  /* ---------- Back to top ---------- */
  function initToTop() {
    var btn = document.querySelector('.sa-totop');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('sa-totop--show', window.scrollY > 600);
    }, { passive: true });
    btn.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Testimonial drag ---------- */
  function initTestimonialDrag() {
    if (!fine) return;
    document.querySelectorAll('[data-sa-testimonials]').forEach(function (root) {
      var viewport = root.querySelector('.sa-testimonials__viewport');
      var track = root.querySelector('.sa-testimonials__track');
      if (!viewport || !track) return;
      var startX = 0, currentX = 0, dragging = false, baseTx = 0;
      function tx() {
        var m = /translateX\(-?([\d.]+)%\)/.exec(track.style.transform || '');
        return m ? -parseFloat(m[1]) : 0;
      }
      viewport.addEventListener('pointerdown', function (e) {
        dragging = true; startX = e.clientX; baseTx = tx();
        viewport.setPointerCapture(e.pointerId);
      });
      viewport.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        currentX = e.clientX;
        var dxPct = (currentX - startX) / viewport.offsetWidth * 100;
        track.style.transition = 'none';
        track.style.transform = 'translateX(' + (baseTx + dxPct) + '%)';
      });
      function end() {
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        var dx = currentX - startX;
        var dots = root.querySelectorAll('.sa-testimonials__dot');
        var active = 0;
        dots.forEach(function (d, i) { if (d.classList.contains('sa-testimonials__dot--active')) active = i; });
        if (dx < -60 && active < dots.length - 1) dots[active + 1].click();
        else if (dx > 60 && active > 0) dots[active - 1].click();
        else if (dots[active]) dots[active].click();
      }
      viewport.addEventListener('pointerup', end);
      viewport.addEventListener('pointercancel', end);
    });
  }

  /* ---------- Extended reveals ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.sa-reveal-left, .sa-reveal-right, .sa-reveal-zoom, .sa-stagger');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('sa-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('sa-visible'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function boot() {
    initParticles();
    initCounters();
    initGuide();
    initCountdown();
    initTilt();
    initMagnetic();
    initHeroParallax();
    initToTop();
    initTestimonialDrag();
    initReveals();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
